import { TradeTradeKindChoices } from "~/generated/graphql"

export const TradeKinds = {
  SaudaPavti: TradeTradeKindChoices.ProForma.toLowerCase(),
  Booking: TradeTradeKindChoices.Booking.toLowerCase(),
  HishobPatti: TradeTradeKindChoices.Final.toLowerCase(),
  InwardPatti: TradeTradeKindChoices.Inward.toLowerCase(),
  StoragePatti: TradeTradeKindChoices.Storage.toLowerCase(),
  OrderPatti: TradeTradeKindChoices.Order.toLowerCase(),
} as const

export const TradeKindsReadable = {
  [TradeKinds.SaudaPavti]: "Sauda Pavti",
  [TradeKinds.Booking]: "Transit Patti",
  [TradeKinds.HishobPatti]: "Hishob Patti",
  [TradeKinds.InwardPatti]: "Inward Patti",
  [TradeKinds.StoragePatti]: "Storage Patti",
  [TradeKinds.OrderPatti]: "Order Patti",
}

export const canAddAdvancePayment = (kind?: string) =>
  kind === TradeKinds.SaudaPavti || kind === TradeKinds.Booking

export const TradeVerifiedStatus = "Verified"

export const hasPendingAdvanceApproval = (trade?: any) =>
  trade?.advance_payments?.some((advance: any) => advance.is_verified === null)

export const UserKinds = {
  ExternalDatabase: "external",
  InternalCompany: "internal",
} as const

export const UserKindsReadable = {
  [UserKinds.ExternalDatabase]: "External Database",
  [UserKinds.InternalCompany]: "Internal Company",
}
